export enum CaseSchedulingType {
  NOW = 'NOW',
  LATER = 'LATER',
}
